<template>
    <div ref="container">
        <div :style="getBackgroundColor" class="color-picker-input" @click="active = true"></div>

        <div class="color-picker-wrapper">
            <div class="color-picker-container">
                <sketch-picker
                    @update:modelValue="onChangeColor"
                    :modelValue="modelValue"
                    v-if="active === true"
                    :disableAlpha="true"
                    :presetColors="isTextColorPicker == true ? presetColorsText : presetColors"
                >
                </sketch-picker>
            </div>
        </div>
    </div>
</template>

<script>
import presetColorsJson from '../../colorpicker-config';
import {Sketch} from "@ckpack/vue-color";

export default {
    name: 'ColorPicker',
    components: {
        'sketch-picker': Sketch,
    },
    data() {
        return {
            active: false,
            presetColors: presetColorsJson.colors.slice(0, 16),
            presetColorsText: presetColorsJson.text_colors.slice(0, 2),
        };
    },
    props: ['modelValue', 'is-text-color-picker'],
    methods: {
        onChangeColor(value) {
            const self = this;

            if (value) {
                self.$emit('update:modelValue', value.hex);
            }
        },
        handleClickOutside(event) {
            if (this.$refs.container && !this.$refs.container.contains(event.target)) {
                this.active = false;
            }
        },
    },
    computed: {
        getBackgroundColor() {
            const self = this;

            return { 'background-color': self.modelValue.hex ? self.modelValue.hex : self.modelValue };
        },
    },
    mounted() {
        const self = this;

        document.addEventListener('click', self.handleClickOutside);
    },
};
</script>
